import { useFormatMessage } from '@zennolab_platform/webui-sdk/dist/hooks';
import { useMemo } from 'react';

import { AnnouncementStatus, AnnouncementType } from '../types/announcement';

/** Status and type names in the admin's language; '—' for a value the admin does not know. */
export function useAnnouncementLabels() {
  const { t } = useFormatMessage();
  return useMemo(() => {
    const unknown = () =>
      t({ id: 'shell.common.unknown', defaultMessage: '—', description: 'Значение, которого админка не знает' });
    const statusLabel = (status: AnnouncementStatus): string => {
      switch (status) {
        case AnnouncementStatus.ANNOUNCEMENT_STATUS_DRAFT:
          return t({ id: 'announcements.status.draft', defaultMessage: 'Черновик', description: 'Статус анонса' });
        case AnnouncementStatus.ANNOUNCEMENT_STATUS_SCHEDULED:
          return t({
            id: 'announcements.status.scheduled',
            defaultMessage: 'Запланирован',
            description: 'Статус анонса',
          });
        case AnnouncementStatus.ANNOUNCEMENT_STATUS_PUBLISHED:
          return t({
            id: 'announcements.status.published',
            defaultMessage: 'Опубликован',
            description: 'Статус анонса',
          });
        case AnnouncementStatus.ANNOUNCEMENT_STATUS_WITHDRAWN:
          return t({
            id: 'announcements.status.withdrawn',
            defaultMessage: 'Снят с публикации',
            description: 'Статус анонса',
          });
        case AnnouncementStatus.ANNOUNCEMENT_STATUS_EXPIRED:
          return t({ id: 'announcements.status.expired', defaultMessage: 'Истёк', description: 'Статус анонса' });
        default:
          return unknown();
      }
    };
    const typeLabel = (type: AnnouncementType): string => {
      switch (type) {
        case AnnouncementType.ANNOUNCEMENT_TYPE_UPDATE:
          return t({ id: 'announcements.type.update', defaultMessage: 'Обновление', description: 'Тип анонса' });
        case AnnouncementType.ANNOUNCEMENT_TYPE_PROMO:
          return t({ id: 'announcements.type.promo', defaultMessage: 'Акция', description: 'Тип анонса' });
        case AnnouncementType.ANNOUNCEMENT_TYPE_MAINTENANCE:
          return t({ id: 'announcements.type.maintenance', defaultMessage: 'Техработы', description: 'Тип анонса' });
        case AnnouncementType.ANNOUNCEMENT_TYPE_NEWS:
          return t({ id: 'announcements.type.news', defaultMessage: 'Новость', description: 'Тип анонса' });
        default:
          return unknown();
      }
    };
    return { statusLabel, typeLabel };
  }, [t]);
}
